import React from "react";
import {render} from "react-dom";
import {Provider} from "react-redux";
import {createStore, applyMiddleware, compose} from "redux";
import {reducers} from "./reducers";
import thunkMiddleware from "redux-thunk";
import {fieldUpdated} from "./actions";
import Form from "./container";

let store = createStore(reducers, compose(
    applyMiddleware(thunkMiddleware),
    window.devToolsExtension ? window.devToolsExtension() : f => f
));

const deliveryForm = document.getElementById('deliveryForm');

if (deliveryForm) {
    render(
        <Provider store={store}>
            <Form/>
        </Provider>,
        deliveryForm
    );
}

store.dispatch(fieldUpdated('name', userName));
store.dispatch(fieldUpdated('email', userEmail));
store.dispatch(fieldUpdated('phone', userPhone));



// WEBPACK FOOTER //
// ./src/delivery/app.js